/* eslint-disable camelcase */
import { JustTime } from 'lib/rise/justtime';
import { ReportInterval, ReportType } from 'app/report-schedule/ReportScheduleConstants';

export class ReportSchedule {
    id: number | null;

    type: ReportType;

    interval: ReportInterval;

    customer_id: number | null;

    location_id: number | null;

    object_id: number | null;

    tour_area_id: number | null;

    day_of_week: number | null;

    time: typeof JustTime | null;

    recipients: Array<string>;

    mail_text: string;

    report_attached_to_mail: boolean;

    no_empty_report_mail: boolean;

    created_at: Date;

    modified_at: Date;

    active: boolean;

    constructor(jsonObject: string | any) {
        let obj = (typeof jsonObject === 'string') ? JSON.parse(jsonObject) : jsonObject;

        if (!obj) {
            obj = {};
        }

        this.id = obj.id ? parseInt(obj.id, 10) : null;
        this.type = obj.type as ReportType;
        this.interval = obj.interval as ReportInterval;
        this.customer_id = obj.customer_id ? parseInt(obj.customer_id, 10) : null;
        this.location_id = obj.location_id ? parseInt(obj.location_id, 10) : null;
        this.object_id = obj.object_id ? parseInt(obj.object_id, 10) : null;
        this.tour_area_id = obj.tour_area_id ? parseInt(obj.tour_area_id, 10) : null;
        this.day_of_week = (obj.day_of_week !== undefined && obj.day_of_week !== null)
            ? parseInt(obj.day_of_week, 10) : null;
        this.recipients = obj.recipients;
        this.active = !!obj.active;
        this.mail_text = obj.mail_text ?? null;
        this.report_attached_to_mail = !!obj.report_attached_to_mail;
        this.no_empty_report_mail = !!obj.no_empty_report_mail;

        if (obj.time) {
            this.time = typeof obj.time === 'string'
                ? JustTime.fromISO(obj.time)
                : obj.time;
        }

        if (obj.created_at) {
            this.created_at = typeof obj.created_at === 'string'
                ? new Date(obj.created_at)
                : obj.created_at;
        }

        if (obj.modified_at) {
            this.modified_at = typeof obj.modified_at === 'string'
                ? new Date(obj.modified_at)
                : obj.modified_at;
        }
    }
}
